<app-navbar-style-two></app-navbar-style-two>

<div class="loading-spinner" *ngIf="loading">
    <div class="spinner"></div>
</div>

<div class="error-message" *ngIf="error">
    <h2>Oops! Something went wrong.</h2>
    <p>We couldn't load the about information. Please try again later.</p>
</div>

<ng-container *ngIf="aboutData && !loading && !error">
    <!-- Banner Section -->
    <section class="pt-5">
        <div class="container-fluid contact-banner mt-5">
            <h2 style="color: #ffffff;">{{aboutData.mainSection.title}}</h2>
            <p class="text-white">{{aboutData.mainSection.subtitle}}</p>
        </div>
    </section>

    <!-- Main About Section -->
    <div class="about-widget-area pt-50 pb-70">
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-6 col-md-12">
                    <div class="about-widget-img">
                        <img [src]="aboutData.mainSection.mainImage" width="100%" height="auto" alt="About RingPilot">
                    </div>
                </div>

                <div class="col-lg-6 col-md-12">
                    <div class="about-widget-content">
                        <div>
                            <h2>Who We Are</h2>
                        </div>
                        <p>{{aboutData.mainSection.description}}</p>
                        
                        <!-- Stats Section -->
                        <div class="row mt-4">
                            <div class="col-md-4" *ngFor="let stat of aboutData.mainSection.stats">
                                <div class="stat-item text-center">
                                    <i [class]="stat.icon"></i>
                                    <h3>{{stat.number}}</h3>
                                    <p>{{stat.title}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Features Section -->
    <div class="service-list-area bg-light pt-100 pb-70">
        <div class="container">
            <div class="text-center">
                <h2>{{aboutData.features.title}}</h2>
                <p class="mb-5">{{aboutData.features.description}}</p>
            </div>

            <div class="row pt-45">
                <div class="col-lg-4 col-md-6" *ngFor="let feature of aboutData.features.items">
                    <div class="service-list-content">
                        <i [class]="feature.icon"></i>
                        <h3>{{feature.title}}</h3>
                        <p>{{feature.description}}</p>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Technology Section -->
    <section class="pt-5">
        <div class="container-fluid contact-banner1 mt-5">
            <h2 style="color: #ffffff;">{{aboutData.technology.title}}</h2>
            <div class="row d-flex justify-content-center">
                <div class="col-md-8 col-sm-12 mb-4">
                    <p class="text-white">{{aboutData.technology.description}}</p>
                </div>
            </div>
            <div class="row justify-content-center">
                <div class="col-md-8">
                    <div class="tech-features">
                        <div class="feature-item" *ngFor="let feature of aboutData.technology.features">
                            <i class="bx bx-check"></i>
                            <span>{{feature}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>

    <!-- Team Section -->
    <div class="container py-5">
        <div class="text-center mb-5">
            <h2 class="fw-bold text-dark">{{aboutData.team.title}}</h2>
            <p class="mb-5">{{aboutData.team.description}}</p>
        </div>

        <div class="row justify-content-center">
            <div class="col-md-3" *ngFor="let member of aboutData.team.members">
                <div class="team-card mb-4">
                    <img [src]="member.image" [alt]="member.name" class="img-fluid rounded-circle mb-3">
                    <h4>{{member.name}}</h4>
                    <p class="position">{{member.position}}</p>
                    <p class="description">{{member.description}}</p>
                </div>
            </div>
        </div>
    </div>

    <!-- Mission Section -->
    <div class="about-widget-area pt-50 pb-70 bg-light">
        <div class="container">
            <div class="text-center mb-5">
                <h2>{{aboutData.mission.title}}</h2>
                <p class="mb-5">{{aboutData.mission.description}}</p>
            </div>

            <div class="row">
                <div class="col-lg-6">
                    <img [src]="aboutData.mission.image" alt="Our Mission" class="img-fluid rounded">
                </div>
                <div class="col-lg-6">
                    <div class="values-list">
                        <div class="value-item" *ngFor="let value of aboutData.mission.values">
                            <h3>{{value.title}}</h3>
                            <p>{{value.description}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Call to Action -->
    <section class="py-5 subscription-section">
        <div class="container text-center text-white">
            <h2 class="fw-bold mb-4 text-white">Ready to transform your business communication?</h2>
            <div class="row justify-content-center">
                <div class="col-auto">
                    <button class="btn start-btn2 fw-bold d-flex align-items-center justify-content-center px-4" routerLink="/contact">
                        Get Started <i class="bi bi-arrow-right ms-2"></i>
                    </button>
                </div>
            </div>
        </div>
    </section>
</ng-container>

<app-footer-style-two></app-footer-style-two>